export {
  SwiperComponent, SwiperDirective,
  coverflowObject, coverflowObjectInterface,
  cubeObject, cubeObjectInterface,
  fadeObject, fadeObjectInterface,
  flipObject, flipObjectInterface,
  SwiperConfig, SwiperConfigInterface,
  SwiperEvents,
  provideDefaultConfig, provideForRootGuard,
  SWIPER_CONFIG, SWIPER_GUARD,
  SwiperModule
} from './lib/index';

